export const ASPECT_RATIO = 4 / 3;
